














































































































































































































import { Component, Vue, Prop, Ref, ProvideReactive } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import {GET_PAYCHECK, PAYCHECK_PDF } from '@/queries/Paycheck';
import {
  GQL_paycheckForm, GQL_paycheckFormVariables,
  GQL_paycheckForm_paycheck_paycheckLines,
  GQL_paycheckForm_paycheck,
} from '@/queries/__generated__/paycheckForm';
import { GQL_PaycheckLineUpdate, GQL_PaycheckUpdate, GQL_PaycheckPrepaymentUpdate } from '@/queries/global';
import PaycheckForm from '@/components/Paycheck/PaycheckForm.vue';
import { UnsavedChanges } from '../decorators/unsaved-changes';
import i18n from '@/i18n';
import PaycheckTimestamps from '@/components/Paycheck/PaycheckTimestamps.vue';
import PaycheckTaxSummary from '@/components/Paycheck/PaycheckTaxSummary.vue';
import PermissionService from '@/utils/permission-service';
import ShowPdfButton from '@/components/Invoicing/Shared/Buttons/ShowPdfButton.vue';
import unitPaycheckSettingsRequiredGuard from '@/guards/unit-paycheck-settings-required-guard';
import Decimal from '@/utils/decimal';
import PaycheckSumsFetcher from '@/components/Paycheck/PaycheckSumsFetcher.vue';
import { GQL_workRelationPaycheckSums_workRelation_paycheckSums } from '@/queries/__generated__/workRelationPaycheckSums';
import { taxCalculator, TaxDeductionCalculationResult } from '@/app/Skatteetaten/tax-deduction';
import { generateUID, WithUID } from '@/utils/utils';
import gql from 'graphql-tag';
import { paycheckFormFragment } from '@/queries/paycheckFragments';
import {
  lineIsTaxDeductionOrdinary, lineIsTaxDeductionVoluntary,
  PaycheckFormLine,
  moveExcessTaxDeductiontoTaxDeductionVolunary,
} from '../components/Paycheck/PaycheckForm';
import formatAmount from '@/filters/formatAmount';

const UPDATE_PAYCHECK = gql`
  mutation updatePaycheck($paycheck: PaycheckUpdate!) {
    updatePaycheck(input: { paycheck: $paycheck }) {
      paycheck {
        ...paycheckFormFragment
      }
    }
  }
  ${paycheckFormFragment}
`;

const UPDATE_PAYCHECK_PAID_DATE = gql`
  mutation updatePaycheckPaidDate($id: ID!, $paidDate: Date) {
    updatePaycheckPaidDate(input: { id: $id, paidDate: $paidDate }) {
      paycheck {
        id
        paidDate
        paidDateUpdatedAt
        paidDateUpdatedBy {
          id name
        }
      }
    }
  }
`;

const LOCK_PAYCHECK = gql`
  mutation lockPaycheck($id: ID!, $taxDeductionTooLowConfirmed: Boolean!) {
    lockPaycheck(input: { id: $id, taxDeductionTooLowConfirmed: $taxDeductionTooLowConfirmed }) {
      paycheck {
        id
        lockedAt
        lockedBy {
          id name
        }
        taxDeductionTooLowConfirmedAt
        taxDeductionTooLowConfirmedBy {
          id name
        }
      }
    }
  }
`;

const REVERT_PAYCHECK = gql `
  mutation revertPaycheck($id: ID!) {
    revertPaycheck(input: { id: $id }) {
      paycheck {
        id
      }
    }
  }
`;

const PAYCHECK_FETCH_LINES_FROM_TEMPLATE = gql`
  mutation fetchPaycheckLinesFromTemplate($id: ID!) {
    fetchPaycheckLinesFromTemplate(input: { id: $id }) {
      paycheck {
        ...paycheckFormFragment
      }
    }
  }
  ${paycheckFormFragment}
`;

const PAYCHECK_FETCH_PAYCHECK_INFO = gql`
  mutation fetchPaycheckInfo($id: ID!) {
    fetchWorkRelationInfoPaycheck(input: { id: $id }) {
      paycheck {
        ...paycheckFormFragment
      }
    }
  }
  ${paycheckFormFragment}
`;

type TaxDeductionLockWarning = {
  isWarningPopupOpen: boolean;
  taxCardAmount: Decimal | null;
  ordinaryTaxDeduction: Decimal | null;
  missingOrdinaryTaxDeduction: Decimal | null;
  lockLoading: boolean;
  voluntaryTaxDeduction: Decimal | null;
}

type TaxDeductionSaveWarning = {
  isWarningPopupOpen: boolean;
  calculatedTaxDeduction: Decimal | null;
  taxDeductionCalculationError: string | null;
  excessTaxDeductionOrdinary: Decimal | null;
  moveAndSaveLoading: boolean;
  saveAsIsLoading: boolean;
}

@Component({
  components: {
    PaycheckForm,
    PaycheckTimestamps,
    PaycheckTaxSummary,
    ShowPdfButton,
    PaycheckSumsFetcher,
  },
  beforeRouteEnter: (to, from, next) => {
    unitPaycheckSettingsRequiredGuard(to, from, next);
  },
})
export default class PaychecksEdit extends Vue {
  @Prop({ type: String, required: true }) private paycheckId!: string;

  @Prop({ type: Boolean, required: true })
  private advancedPaycheckMode!: boolean;

  @Ref() private readonly paycheckForm?: PaycheckForm;
  @Ref() private readonly paycheckSumsFetcher?: PaycheckSumsFetcher;

  @SmartQuery<PaychecksEdit, GQL_paycheckForm, GQL_paycheckFormVariables>({
    query: GET_PAYCHECK,
    fetchPolicy: 'network-only',
    variables() { return { id: this.paycheckId } },
    update: data => ({
      ...data.paycheck!,
      logo: data.paycheck!.logo,
      unitId: data.paycheck!.unit.id,
      currencyCode: data.paycheck!.currencyCode,
      workRelationId: data.paycheck!.workRelation.id,
      companyMunicipalityId: data.paycheck!.companyMunicipality.id,
      paycheckLines: data.paycheck!.paycheckLines.map(line => ({
        ...line,
        paycheckLineTemplateId: line.paycheckLineTemplate?.id || '',
        carId: line.car?.id || '',
        projectId: line.project?.id || '',
        departmentId: line.department?.id || '',
        $_UID: generateUID(),
      } as GQL_paycheckForm_paycheck_paycheckLines & GQL_PaycheckLineUpdate)),
    } as GQL_paycheckForm_paycheck & GQL_PaycheckUpdate),
  }) private paycheck!: GQL_paycheckForm_paycheck & GQL_PaycheckUpdate;

  private get notDeletedLines(): WithUID<PaycheckFormLine>[] {
    return (this.paycheck.paycheckLines as WithUID<PaycheckFormLine>[])
      .filter((line) => !(line as unknown as {_destroy: boolean})._destroy);
  }

  private validForm = true;
  @UnsavedChanges<PaychecksEdit>({
    messages: {
      entity: i18n.t('Paycheck.paycheck'),
    },
    saveAndContinue() {
      return this.saveAndContinue();
    },
  })
  private dirtyForm = false;
  private UPDATE_PAYCHECK = UPDATE_PAYCHECK;
  private LOCK_PAYCHECK = LOCK_PAYCHECK;
  private UPDATE_PAYCHECK_PAID_DATE = UPDATE_PAYCHECK_PAID_DATE;
  private PAYCHECK_FETCH_PAYCHECK_INFO = PAYCHECK_FETCH_PAYCHECK_INFO;
  private PAYCHECK_FETCH_LINES_FROM_TEMPLATE = PAYCHECK_FETCH_LINES_FROM_TEMPLATE;
  private PAYCHECK_PDF = PAYCHECK_PDF;

  private formatAmount = formatAmount;

  private get isLocked(): boolean {
    return !!this.paycheck.lockedAt;
  }

  private get hasEditPermissions(): boolean {
    return PermissionService.check('canCreatePaychecks');
  }

  private i18nMoveVoluntaryTaxToVoluntaryLine() {
    return this.$t(
      "Paycheck.moveVoluntaryTaxToVoluntaryLine",
      { amount: formatAmount(this.taxDeductionSaveWarning?.excessTaxDeductionOrdinary?.times(-1) ?? null) },
    );
  }
  private i18nSavePaycheckAsIs() {
    return this.$t("Paycheck.TaxDeductionSaveWarning.savePaycheckAsIs");
  }

  private formatForMutation(paycheck: GQL_paycheckForm_paycheck & GQL_PaycheckUpdate): GQL_PaycheckUpdate {
    return {
      id: paycheck.id,
      currencyCode: paycheck.currencyCode,
      startDate: paycheck.startDate,
      endDate: paycheck.endDate,
      dueDate: paycheck.dueDate,
      companyMunicipalityId: paycheck.companyMunicipalityId,
      employeeBban: paycheck.employeeBban,
      employeeIban: paycheck.employeeIban,
      employeeSwift: paycheck.employeeSwift,
      paidDate: paycheck.paidDate,
      comment: paycheck.comment,
      internalComment: paycheck.internalComment,
      journalDate: paycheck.journalDate,
      taxDeductionMethod: paycheck.taxDeductionMethod,

      shouldSendToAltinn: paycheck.shouldSendToAltinn,
      shouldSendToFakturabank: paycheck.shouldSendToFakturabank,

      paycheckLines: (paycheck.paycheckLines as Array<GQL_paycheckForm_paycheck_paycheckLines & GQL_PaycheckLineUpdate>).map(line => ({
        id: line.id,
        paycheckLineTemplateId: line.paycheckLineTemplateId,
        quantity: line.quantity,
        rate: line.rate,
        sum: line.sum,
        carId: line.carId,
        projectId: line.projectId,
        departmentId: line.departmentId,
        altinnAdditional: line.altinnAdditional,
        _destroy: line._destroy || undefined,
      } as GQL_PaycheckLineUpdate)),
      prepayments: (paycheck.prepayments as Array<GQL_PaycheckPrepaymentUpdate>).map(prepayment => ({
        id: prepayment.id,
        amount: prepayment.amount,
        paymentDate: prepayment.paymentDate,
        _destroy: prepayment._destroy || undefined,
      })),
    } as GQL_PaycheckUpdate;
  }

  revertPaycheck(paycheck: GQL_paycheckForm_paycheck) {
    return this.$apollo
     .mutate({
       mutation: REVERT_PAYCHECK,
       variables: { id: paycheck.id },
    })
     .then((data) => {
        this.$router.push({
          name: 'AdvancedPaychecksEdit',
          params: { id: data.data.revertPaycheck!.paycheck.id },
        });
    });
  }

  private onFetchPaycheckInfo(): void {
    this.$sMessage.success(this.$t('Paycheck.fetchPaycheckInfoSuccess'));
    this.resetFormDirty();
  }

  private onFetchLinesFromTemplate(): void {
    this.$sMessage.success(this.$t('Paycheck.fetchLinesFromTemplateSuccess'));
    this.resetFormDirty();
  }

  private confirmOverwriteAction(mutation: () => {}): void {
    this.$sPopup.alert(``, {
      title: this.$t('Paycheck.areYouSure'),
      message: this.$t('Paycheck.thisWillOverwritePaycheck'),
      withCloseButton: false,
      buttons: [
        {
          text: this.$t('yes'),
          color: 'primary',
          click: () => {
            if (this.dirtyForm) {
              this.$sPopup.alert(``, {
                title: this.$t('Paycheck.thereAreUnsavedChanges'),
                message: this.$t('Paycheck.saveBeforeProceeding'),
                buttons: [
                  {
                    text: this.$t('yes'),
                    color: 'primary',
                    click: () => {
                      this.saveAndContinue()
                        .then((savedSuccessfully) => {
                          if (savedSuccessfully) {
                            mutation();
                            this.resetFormDirty();
                          }
                        });
                    },
                  },
                  {
                    text: this.$t('no'),
                    click: () => mutation(),
                  },
                ],
              });
            } else {
              mutation();
              this.resetFormDirty();
            }
          },
        },
        {
          text: this.$t('no'),
          click: () => {},
        },
      ],
    });
  }

  private saveAndContinue(): Promise<boolean> {
    if (this.isLocked) {
      return this
        .updatePaycheckPaidDate()
        .then(() => { return true })
        .catch(() => { return false });
    } else {
      return this
        .updatePaycheck()
        .then(() => { return true})
        .catch(() => { return false });
    }
  }

  @ProvideReactive()
  private paycheckSums: GQL_workRelationPaycheckSums_workRelation_paycheckSums[] | null = null;

  private setPaycheckSums(paycheckSums: GQL_workRelationPaycheckSums_workRelation_paycheckSums[]) {
    this.paycheckSums = paycheckSums;
  }

  public async calculateTaxDeduction(): Promise<TaxDeductionCalculationResult> {
    const calculator = taxCalculator(this.paycheck, this.paycheckSums!);
    if(!this.paycheck.taxDeductionMethod) {
      return calculator.emptyTaxDeductionCalculation();
    }

    return await calculator.calculateTaxDeduction(this.paycheck.taxDeductionMethod);
  }

  private taxDeductionSaveWarning: TaxDeductionSaveWarning = {
    isWarningPopupOpen: false,
    calculatedTaxDeduction: null,
    taxDeductionCalculationError: null,
    excessTaxDeductionOrdinary: null,
    moveAndSaveLoading: false,
    saveAsIsLoading: false,
  }
  private updatePaycheckLoading = false;
  private async checkTaxDeductionAndUpdate() {
    const taxDeductionWarning = await this.calculateTaxDeduction();

    if (taxDeductionWarning.kind === `calculation`) {
      const ordinaryTaxDeduction: Decimal = this.notDeletedLines
        .filter(lineIsTaxDeductionOrdinary)
        .reduce(((acc, line) => acc.plus(line.sum)), new Decimal(0));
      const taxCardAmount: Decimal = taxDeductionWarning.taxDeduction.times(-1);

      this.taxDeductionSaveWarning.calculatedTaxDeduction = taxDeductionWarning.taxDeduction;
      this.taxDeductionSaveWarning.taxDeductionCalculationError = taxDeductionWarning.error;

      if (ordinaryTaxDeduction.lessThan(taxCardAmount)) {
        this.taxDeductionSaveWarning.excessTaxDeductionOrdinary =
          ordinaryTaxDeduction.minus(taxCardAmount);
        this.taxDeductionSaveWarning.isWarningPopupOpen = true;
        return;
      }
    }

    this.taxDeductionSaveWarning.excessTaxDeductionOrdinary = null;
    this.updatePaycheckLoading = true;
    return this.updatePaycheck()
      .finally(() => { this.updatePaycheckLoading = false });
  }

  private updatePaycheck() {
    return this
      .$apollo
      .mutate({
        mutation: UPDATE_PAYCHECK,
        variables: { paycheck: this.formatForMutation(this.paycheck) },
      })
      .then(() => {
        this.$sMessage.success(this.$t('Message.saveSuccess'));

        this.paycheckSumsFetcher && this.paycheckSumsFetcher.refetchPaycheckSums();
        this.resetFormDirty();
      });
  }

  private moveExcessTaxDeductiontoTaxDeductionVolunaryAndSave() {
    const taxDeductionToMove = this.taxDeductionSaveWarning.excessTaxDeductionOrdinary;
    if (!taxDeductionToMove) return;

    this.taxDeductionSaveWarning.moveAndSaveLoading = true;
    moveExcessTaxDeductiontoTaxDeductionVolunary(this.paycheck, taxDeductionToMove)
      .then(() => { return this.updatePaycheck() })
      .finally(() => {
        this.taxDeductionSaveWarning.moveAndSaveLoading = false;
        this.taxDeductionSaveWarning.isWarningPopupOpen = false;
      });
  }

  private savePaycheckAsIs() {
    this.taxDeductionSaveWarning.saveAsIsLoading = true;
    this.updatePaycheck()
      .finally(() => {
        this.taxDeductionSaveWarning.saveAsIsLoading = false;
        this.taxDeductionSaveWarning.isWarningPopupOpen = false;
      });
  }

  private updatePaycheckPaidDateLoading = false;
  private updatePaycheckPaidDate() {
    this.updatePaycheckPaidDateLoading = true;

    return this
      .$apollo
      .mutate({
        mutation: UPDATE_PAYCHECK_PAID_DATE,
        variables: { id: this.paycheck.id, paidDate: this.paycheck.paidDate },
      }).then(() => {
        this.$sMessage.success(this.$t('Message.saveSuccess'));

        this.paycheckSumsFetcher && this.paycheckSumsFetcher.refetchPaycheckSums();
        this.resetFormDirty();
      })
      .finally(() => {
        this.updatePaycheckPaidDateLoading = false;
      });
  }

  private taxDeductionLockWarning: TaxDeductionLockWarning = {
    taxCardAmount : null,
    ordinaryTaxDeduction:  null,
    missingOrdinaryTaxDeduction: null,
    voluntaryTaxDeduction: null,
    lockLoading: false,
    isWarningPopupOpen: false,
  }

  private lockPaycheckLoading = false;
  private async checkTaxDeductionAndLock() {
    if (this.paycheck.taxDeductionMethod) {
      const taxDeductionCalculation = await taxCalculator(this.paycheck, this.paycheckSums!).calculateTaxDeduction(this.paycheck.taxDeductionMethod);

      if (taxDeductionCalculation.kind === `calculation`) {
        this.taxDeductionLockWarning.taxCardAmount = taxDeductionCalculation.taxDeduction;
        this.taxDeductionLockWarning.ordinaryTaxDeduction = this.notDeletedLines
          .filter(lineIsTaxDeductionOrdinary)
          .reduce(((acc, line) => acc.plus(line.sum)), new Decimal(0))
          .abs();

        this.taxDeductionLockWarning.voluntaryTaxDeduction = this.notDeletedLines
          .filter(lineIsTaxDeductionVoluntary)
          .reduce(((acc, line) => acc.plus(line.sum)), new Decimal(0))
          .abs();

        this.taxDeductionLockWarning.missingOrdinaryTaxDeduction =
          this.taxDeductionLockWarning.ordinaryTaxDeduction
            .minus(this.taxDeductionLockWarning.taxCardAmount);

        if (this.taxDeductionLockWarning.missingOrdinaryTaxDeduction.lessThan(0)) {
          this.taxDeductionLockWarning.isWarningPopupOpen = true;
          return;
        }
      }
    }

    this.lockPaycheckLoading = true;
    this.lock()
      .finally(() => this.lockPaycheckLoading = false);
  }

  private lockWarningClickLock() {
    this.taxDeductionLockWarning.lockLoading = true;
    this.lock(true)
      .finally(() => {
        this.taxDeductionLockWarning.lockLoading = false;
        this.taxDeductionLockWarning.isWarningPopupOpen = false;
      });
  }

  private lock(taxDeductionTooLowConfirmed = false) {
    return this.$apollo
      .mutate({
        mutation: LOCK_PAYCHECK,
        variables: {
          id: this.paycheck.id,
          taxDeductionTooLowConfirmed,
        },
      })
      .then(() => {
        this.$sMessage.success(this.$t('Message.lockSuccess'));
        this.resetFormDirty();
      });
  }

  private resetFormDirty(): void {
    this.paycheckForm && this.paycheckForm.resetFormDirty();
  }
}
